var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFoghorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 210,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1005,
    y: 499,
    width: 123,
    height: 210
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1005 -499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.154 75.4746 238.774 88.8542C281.314 131.394 281.314 200.694 238.774 243.234L252.154 256.614C302.241 206.869 302.241 125.562 252.154 75.4746Z",
    stroke: "#000000",
    strokeWidth: 3.43066,
    transform: "matrix(1 0 0 1.02663 829.901 432.324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.052 102.234 211.672 115.613C239.46 143.402 239.46 188.343 211.672 216.475L225.052 229.854C260.387 194.519 260.387 137.57 225.052 102.234Z",
    stroke: "#000000",
    strokeWidth: 3.43066,
    transform: "matrix(1 0 0 1.02663 829.901 432.324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.635 129.679 185.256 143.059C198.292 156.095 198.292 177.022 185.256 190.059L198.635 203.438C219.219 182.854 219.219 149.92 198.635 129.679Z",
    stroke: "#000000",
    strokeWidth: 3.43066,
    transform: "matrix(1 0 0 1.02663 829.901 432.324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0073 118.701 12.0073 210.643 78.5622 210.643 164.672 281.314 164.672 48.0293 78.5622 118.701Z",
    stroke: "#000000",
    strokeWidth: 3.43066,
    transform: "matrix(1 0 0 1.02663 829.901 432.324)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoghorn);
export default __webpack_public_path__ + "static/media/Foghorn.94227eafb141752abeb9a4777bb2ac13.svg";
export { ForwardRef as ReactComponent };